var _a;
import { createSelector } from 'reselect';
import { AppConstant } from 'constants/app.constant';
import { createAction, handleActions } from 'redux-actions';
import Immutable from 'seamless-immutable';
var initialState = Immutable({
    selectedCampusId: null,
    programIds: [],
    campuses: [],
    favoriteCards: [],
    pinnedCategoryGroups: []
});
var prefixActionName = 'DP';
var restoreState = createAction("".concat(prefixActionName, "/RESTORE"));
var setSelectedCampusId = createAction("".concat(prefixActionName, "/SET_SELECTED_CAMPUS_ID"));
var setSelectedProgramIds = createAction("".concat(prefixActionName, "/SET_SELECTED_PROGRAM_IDS"));
var setSelectedProgramTabId = createAction("".concat(prefixActionName, "/SET_SELECTED_PROGRAM_TAB_ID"));
var setCampuses = createAction("".concat(prefixActionName, "/SET_CAMPUSES"));
var setFavoriteCards = createAction("".concat(prefixActionName, "/SET_FAVORITES"));
var setPinnedCategoryGroups = createAction("".concat(prefixActionName, "/SET_PINNED_CATEGORY_GROUPS"));
var actions = {
    restoreState: restoreState,
    setSelectedCampusId: setSelectedCampusId,
    setSelectedProgramIds: setSelectedProgramIds,
    setSelectedProgramTabId: setSelectedProgramTabId,
    setCampuses: setCampuses,
    setFavoriteCards: setFavoriteCards,
    setPinnedCategoryGroups: setPinnedCategoryGroups
};
var reducer = handleActions((_a = {},
    _a[actions.restoreState] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.merge(state, payload);
    },
    _a[actions.setSelectedCampusId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedCampusId', payload);
    },
    _a[actions.setSelectedProgramIds] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'programIds', payload);
    },
    _a[actions.setSelectedProgramTabId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'programTabId', payload);
    },
    _a[actions.setCampuses] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'campuses', payload);
    },
    _a[actions.setFavoriteCards] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'favoriteCards', payload);
    },
    _a[actions.setPinnedCategoryGroups] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'pinnedCategoryGroups', payload);
    },
    _a), initialState);
var getDpState = function (state) { return state[AppConstant.reduxResources.DP_STATE]; };
var selectors = {
    getSelectedCampusId: createSelector(getDpState, function (state) { return state.selectedCampusId; }),
    getProgramIds: createSelector(getDpState, function (state) { return state.programIds; }),
    getCampuses: createSelector(getDpState, function (state) { return state.campuses; }),
    getSelectedProgramTabId: createSelector(getDpState, function (state) { return state.programTabId; }),
    getFavoriteCards: createSelector(getDpState, function (state) { return state.favoriteCards; }),
    getPinnedCategoryGroups: createSelector(getDpState, function (state) { return Immutable.asMutable(state.pinnedCategoryGroups || [], { deep: true }); })
};
export { actions as dpActions, reducer as dpReducer, selectors as dpSelectors };
export { initialState as dpInitialState };
